module.exports = __webpack_public_path__ + "media/img/mask/triangle-2aa5d27b53d977e0e06faafdba5a84a0.svg";